module.exports = "/images/logo-ep-ai-red.svg";